module.exports = __webpack_public_path__ + "static/media/check.e3ea6066.svg";